// removed by extract-text-webpack-plugin
module.exports = {"variables":"'src/styles/variables.css'","gray-chateau":"#9099A7","container":"media-page__container__e4bFu","gallery":"media-page__gallery__2Z1M9","no-media-section":"media-page__no-media-section__2PiCd","no-media-icon":"media-page__no-media-icon__1-fqU","no-media-header":"media-page__no-media-header__imIJ7","no-media-description":"media-page__no-media-description__3GflS","plus-round-icon":"media-page__plus-round-icon__2d3HG","media-empty-icon":"media-page__media-empty-icon__2c7jm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/media-page.scss
// module id = 1449
// module chunks = 1